<template>
    <v-dialog fullscreen v-model="dialog">
        <template v-slot:activator="{ on, attrs }">
            <p v-bind="attrs" v-on="on">Info Sessions</p>
        </template>
        <v-card class="d-flex justify-center align-center">
            <div style="width: 400px" class="d-flex flex-column">
                <v-select class="select" @change="openInnerDialog" v-model="select" autofocus item-text="label" item-value="label" :items="items" label="Information Sessions" return-object>Pick me</v-select>
                <v-btn color="error" @click.stop="closeDialogs">Close</v-btn>
            </div>
        </v-card>
        <InfoSessionTable :all-attendees="getShowList" :dialog="innerDialog" @update-inner-dialog="updateInnerDialog"/>
    </v-dialog>
</template>

<script>
import axios from 'axios'
import {getAllInfoSessionsList} from "../../../../../../services/ApiServices";
import InfoSessionTable from "./InfoSessionTable";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "InfoSessionModal",
  components: {InfoSessionTable},
  data: () => ({
    dialog: false,
    innerDialog: false,
    items: [],
    select: {},
  }),
  created() {
    console.log('infoSession')
    const headers = JSON.parse(sessionStorage.getItem('headers'))
    // axios.get(getAllInfoSessions(), {headers: headers})
    axios.get(getAllInfoSessionsList(), {headers: headers})
        .then(res => {
          console.log(res.data)
          const infoSessions = res.data
              .map(infoSession =>
                  this.updateInfoSession({
                    ...infoSession,
                    label: `${infoSession.mode} InfoSession on ${infoSession.sessionDate} at ${infoSession.sessionTime}`
                  }))
          this.setInfoSessions(infoSessions)
          infoSessions.map(infoSession => {
            this.items.push({label: infoSession.label, id: infoSession.infoSessionId})
                })
            })
        },
        methods: {
            ...mapActions(['setShowList', 'setInfoSessions', 'fetchInfoSession']),
            updateInfoSession(infoSession) {
                return infoSession
            },
            openInnerDialog() {
                this.fetchInfoSession(this.select.id)
                this.setShowList()
                this.innerDialog = true
            },
            closeDialogs() {
                this.dialog = false
                this.select = {}
            },
            updateInnerDialog(innerDialog) {
                this.innerDialog = innerDialog
            }
        },
        computed: {
            ...mapGetters(['getShowList', 'getInfoSessions'])
        }
    }
</script>

<style scoped>
    .select {
        max-width: 400px !important;
        padding: 0 !important;
    }
</style>